




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Action, Mutation } from 'vuex-class';
import { Build } from '@/types/build';
import moment from 'moment';

@Component
export default class BuildListTile extends Vue {
  @Prop() build!: Build;
  @Action('builds/saveBuild') saveBuild!: Function;
  @Mutation('builds/setQueueToBonza') setQueueToBonza!: Function;

  get createdAt(): string {
    moment.locale('en-gb');
    return moment(this.build.created_at as string).calendar();
  }

  get creator(): string {
    return this.build.user === null
      ? 'Unknown Instigator'
      : this.build.user.first_name + ' ' + this.build.user.last_name;
  }

  stopBuild() {
    this.build.failed = 1;
    this.build.complete = 1;
    this.build.in_progress = 0;
    this.saveBuild(this.build);
    this.setQueueToBonza();
  }
}
